import { SxProps, Theme } from '@mui/material';

import { MuiColors } from '@/types/colors';

export const inputStyles: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    minHeight: 38,
    height: 'auto',
    maxHeight: 120,
    overflow: 'auto',
    padding: '4px',
    '& fieldset': {
      borderRadius: '8px',
      borderColor: 'var(--secondary-color)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--secondary-color)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--secondary-color)',
      outline: 'none',
    },
    '& input': {
      padding: '4px 8px',
      height: 24,
      boxSizing: 'border-box',
      color: MuiColors.primaryColor,
      fontFamily: 'Montserrat',
      outline: 'none',
    },
    '& input:focus': {
      outline: 'none',
    },
    '& .MuiAutocomplete-tag': {
      margin: '2px',
      maxWidth: '200px',
    },
  },
};

export const paperStyles: SxProps<Theme> = {
  marginTop: '8px',
  borderRadius: '12px',
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15), 0px 2px 8px rgba(0, 0, 0, 0.1)',
};

export const listboxStyles: SxProps<Theme> = {
  paddingTop: '8px',
  paddingBottom: '8px',
};

export const optionItemStyles: React.CSSProperties = {
  backgroundColor: 'transparent',
  borderRadius: '8px',
  margin: '2px 8px',
};

export const checkboxStyles: SxProps<Theme> = {
  padding: 0,
  marginRight: 1,
};
